// French: reference language. Every key must exist here; en.ts and ar.ts
// fall back to it for any missing key.
export default {
  common: {
    loading: "Chargement...",
  },
  header: {
    openMenu: "Ouvrir le menu",
    home: "Accueil",
    language: "Langue",
    searchPlaceholder: "Rechercher une page...",
    searchLabel: "Rechercher une page",
    noResult: "Aucun résultat trouvé",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} non lue(s)",
    markAllRead: "Tout marquer comme lu",
    noNotifications: "Aucune notification",
    onlineAccount: "Compte en ligne",
    myAccount: "Mon compte",
    myProfile: "Mon profil",
    profile: "Profil",
    settings: "Paramètres",
    logout: "Déconnexion",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Livreur",
    roleZoneManager: "Responsable de zone",
    justNow: "À l'instant",
    minutesAgo: "Il y a {n} min",
    hoursAgo: "Il y a {n} h",
  },
  theme: {
    enableLight: "Activer le mode clair",
    enableDark: "Activer le mode sombre",
    light: "Mode clair",
    dark: "Mode sombre",
  },
  sidebar: {
    mainNav: "Navigation principale",
    mainMenu: "Menu principal",
    closeMenu: "Fermer le menu",
    loadingMenu: "Chargement du menu",
  },
  menu: {
    dashboard: "Dashboard",
    parcels: "Colis",
    distributionNotes: "Bons distribution",
    exchanges: "Échange",
    returns: "Retours",
    refunds: "Remboursements",
    driverInvoices: "Factures livreurs",
    myProfile: "Mon profil",
    apiDocs: "Documentation API",
    deliveryNotes: "Bons de livraison",
    parcelReception: "Réception colis",
    sentNotes: "Bons d'envoi",
    zoneInvoices: "Factures zones",
    zoneReturns: "Retours zones",
    claims: "Réclamations",
    users: "Utilisateurs",
    usersList: "Liste des utilisateurs",
    newDrivers: "Nouveaux livreurs",
  },
};
